import React from 'react';
import Linkify from 'react-linkify';
import { SecureLink } from 'react-secure-link';
import { parseEmojis } from '../../../utils/parse-emojis';
import { successResult } from 'open-graph-scraper';
import { Store } from '../../../store';

type EmojiAndLinkifiedTextProps = {
  body: string;
  id: string;
};

export const EmojiAndLinkifiedText: React.FC<EmojiAndLinkifiedTextProps> = (props) => {
  const { body, id } = props;
  const getOpenGraphImage = async (decoratedHref: string) => {
    const data: Omit<successResult['result'], 'ogVideo'> & {
      ogVideo: string | undefined | { url: string; height: string; type: string; width: string };
    } = await fetch('https://chat-widget.withremark.com/api/open-graph', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ url: decoratedHref })
    })
      .then((resp) => resp.json())
      .catch();
    if (data?.ogImage && data?.ogTitle) {
      Store.update((s) => {
        s.ogLinkInfo[id] = {
          title: data.ogTitle ?? '',
          image:
            typeof data.ogImage === 'string'
              ? data.ogImage
              : Array.isArray(data.ogImage)
              ? data.ogImage[0]?.url
              : data.ogImage?.url ?? '',
          link: decoratedHref,
          currency: data?.ogPriceCurrency,
          price: data?.ogPriceAmount ? Number(data?.ogPriceAmount) : undefined,
          video:
            typeof data.ogVideo === 'string'
              ? data.ogVideo
              : typeof data?.ogVideo === 'object'
              ? data.ogVideo?.url
              : ''
        };
      });
    }
  };
  const openGraphInfo = Store.useState((s) => s.ogLinkInfo[id]);
  return (
    // @ts-ignore
    <Linkify
      componentDecorator={(decoratedHref, decoratedText, key) => {
        if (decoratedHref && !openGraphInfo) {
          getOpenGraphImage(decoratedHref);
        }
        return (
          <SecureLink
            href={decoratedHref}
            key={key}
            style={{ textDecoration: 'underline' }}
            tabIndex={-1}
            id={`message-link-${id}-${key}`}
          >
            {decoratedText}
          </SecureLink>
        );
      }}
    >
      {parseEmojis(body)}
    </Linkify>
  );
};
